import { ArrowLeft, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { Button } from './ui/button';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  icon?: LucideIcon;
  onBack?: () => void;
  /** The back button's accessible name, for a page that can say where it goes back to. */
  backLabel?: string;
}

export function PageHeader({
  title,
  description,
  actions,
  icon: Icon,
  onBack,
  backLabel = 'Go back',
}: PageHeaderProps) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex items-start gap-3">
        {onBack ? (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={onBack}
            aria-label={backLabel}
            className="mt-0.5 shrink-0 text-foreground"
          >
            <ArrowLeft className="h-[18px] w-[18px]" />
          </Button>
        ) : null}

        {Icon ? (
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Icon className="h-[18px] w-[18px]" aria-hidden />
          </span>
        ) : null}

        <div className="flex flex-col gap-1">
          <h1 className="text-title text-foreground">{title}</h1>
          {description ? (
            <p className="max-w-[68ch] text-sm leading-relaxed text-muted-foreground">
              {description}
            </p>
          ) : null}
        </div>
      </div>

      {actions}
    </header>
  );
}
